import React from 'react';
import { IconName, Icon } from '@televet/kibble-ui/build/components/Icon';
import { Tag } from '@televet/kibble-ui/build/components/Tag';
import { SemanticBackgroundColorToken } from '@televet/kibble-ui/build/theme/tokens';

interface StatusTagProps {
  label: string;
  bg: SemanticBackgroundColorToken | string;
  iconName?: IconName;
  textColor?: string;
  useLeftElement?: boolean;
  borderRadius?: string;
  fontWeight?: string;
  onClick?: () => void;
}

const StatusTag = ({ label, bg, iconName, useLeftElement, textColor, borderRadius, fontWeight, onClick }: StatusTagProps): JSX.Element => {
  return (
    <Tag
      label={label}
      bg={bg}
      rightElement={!useLeftElement && iconName && <Icon size="sm" name={iconName} />}
      leftElement={useLeftElement && iconName && <Icon size="sm" name={iconName} />}
      cursor={onClick ? 'pointer' : 'default'}
      onClick={onClick}
      borderRadius={borderRadius ?? "sm"}
      color={textColor ?? "text.default"}
      fontWeight={fontWeight ?? "regular"}
      minW="fit-content"
    />
  );
};

export default StatusTag;
